<template>
  <section class="page-container">
    <div class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item label="商品类型">
          <el-select v-model="filters.type" placeholder="商品类型">
            <el-option :value="1" label="兑换商品"></el-option>
            <el-option :value="2" label="抽奖商品"></el-option>
            <el-option :value="3" label="保底兑换"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" placeholder="状态">
            <el-option :value="0" label="启用"></el-option>
            <el-option :value="1" label="禁用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">Query</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">Add</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      v-loading="listLoading"
      :data="results"
      highlight-current-row
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="编号"></el-table-column>

      <el-table-column prop="status" label="商品类型">
        <template slot-scope="scope">{{
          scope.row.type === 1 ? "兑换商品" : scope.row.type === 2 ? "抽奖商品" : "保底兑换"
        }}</template>
      </el-table-column>

      <el-table-column prop="title" label="标题"></el-table-column>

      <el-table-column prop="image" label="图片">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.image && scope.row.image.url"
            :src="scope.row.image.url"
            :preview-src-list="[scope.row.image.url]"
            style="width: 100px; height: 100px"
            fit="cover"
          />
        </template>
      </el-table-column>

      <el-table-column prop="score" label="积分"></el-table-column>

      <el-table-column prop="couponId" label="优惠券ID"></el-table-column>

      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">{{ scope.row.status === 0 ? "启用" : "禁用" }}</template>
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
      </el-table-column>

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <el-dialog title="Add" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="80px">
        <el-form-item label="商品类型">
          <el-select v-model="addForm.type" placeholder="商品类型">
            <el-option :value="1" label="兑换商品"></el-option>
            <el-option :value="2" label="抽奖商品"></el-option>
            <el-option :value="3" label="保底兑换"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片">
          <image-obj-upload v-model="addForm.image" />
        </el-form-item>

        <el-form-item label="标题">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>

        <el-form-item label="积分">
          <el-input v-model="addForm.score"></el-input>
        </el-form-item>

        <el-form-item label="优惠券ID">
          <el-input
            v-model.trim="addForm.couponId"
            placeholder="关联优惠券ID，用户领取后会自动发放该优惠券"
          ></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="addForm.status" placeholder="请选择状态">
            <el-option :value="0" label="启用"></el-option>
            <el-option :value="1" label="禁用"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">Submit</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="80px">
        <el-input v-model="editForm.id" type="hidden"></el-input>

        <el-form-item label="商品类型">
          <el-select v-model="editForm.type" placeholder="商品类型">
            <el-option :value="1" label="兑换商品"></el-option>
            <el-option :value="2" label="抽奖商品"></el-option>
            <el-option :value="3" label="保底兑换"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片">
          <image-obj-upload v-model="editForm.image" />
        </el-form-item>

        <el-form-item label="标题">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>

        <el-form-item label="积分">
          <el-input v-model="editForm.score"></el-input>
        </el-form-item>

        <el-form-item label="优惠券ID">
          <el-input
            v-model.trim="editForm.couponId"
            placeholder="关联优惠券ID，用户领取后会自动发放该优惠券"
          ></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="editForm.status" placeholder="请选择状态">
            <el-option :value="0" label="启用"></el-option>
            <el-option :value="1" label="禁用"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit"
          >Submit</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import ImageObjUpload from "@/components/ImageObjUpload";
export default {
  components: { MyPagination, ImageObjUpload },
  data() {
    return {
      results: [],
      listLoading: false,
      page: {},
      filters: {
        status: 0,
      },
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    async list() {
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/goods/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      try {
        const params = Object.assign({}, this.addForm);
        if (this.addForm.image) {
          params.image = JSON.stringify(this.addForm.image);
        }
        await this.axios.form("base:/api/admin/goods/create", params);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("base:/api/admin/goods/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      try {
        const params = Object.assign({}, this.editForm);
        if (this.editForm.image) {
          params.image = JSON.stringify(this.editForm.image);
        }
        await this.axios.form("base:/api/admin/goods/update", params);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
